var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-content"},[_c('div',{staticClass:"show-box"},_vm._l((_vm.showList),function(item,index){return _c('div',{key:index,staticClass:"show-list",on:{"click":function($event){return _vm.toPath(item.url)}}},[_c('div',{staticClass:"title"},[_vm._v("名称："+_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }